const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowPickupConfirmation', ['$rootScope','$window','$location','$stateParams','RescheduleDeliveryService', require('./pickupconfirmation-directives')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/pickupconfirmation/index.js
 **/